import { Layout } from '@/components/generic';
import { useTranslation } from 'react-i18next';

import Pricing from './Pricing';

export const Newcard = () => {
  const { t } = useTranslation();

  return (
    <div className='min-h-screen bg-b-surface1 font-inter text-body-1 text-t-primary antialiased'>
      <Layout title={t('newcard.title')}>
        <Pricing />
      </Layout>
    </div>
  );
};
